export const VERSION = 'dev-master#3b94d7c';
